/* eslint-disable react/prop-types */
import { InputAdornment, MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'

import { fetchPaymentMethod, makeReport } from '../PaymentTypeActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import Icon from '@mdi/react'
import {
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
} from '@mdi/js'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import filterStylesComponents from '../../../assets/filterComponentsStyles'

export default function Filter(props) {
  const items = useSelector(state => state.paymentMethod.items)

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const { classes } = props
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()
  const filterClasses = filterStylesComponents()

  const onSubmit = data => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit(values)
  }

  const handleStatusChange = e => {
    const status = e.target.value
    onSubmit({ ...filters, status })
  }

  const handleReportExport = () => {
    dispatch(makeReport(filters))
  }

  return (
    <BaseFilter>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={8}>
              <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item sm={4} xs={12}>
                    <TextField
                      fullWidth
                      name="name"
                      defaultValue={filters?.name || ''}
                      label="Filtre por nome"
                      className={classes.inputFilter}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton type="submit" aria-label="search">
                              <Icon path={mdiMagnifyExpand} size={1} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item sm={4} xs={12}>
                    <TextField
                      select
                      fullWidth
                      name="status"
                      value={filters?.status || ''}
                      onChange={handleStatusChange}
                      label="Filtre por status"
                      className={classes.inputFilter}
                    >
                      <MenuItem value="">Selecione...</MenuItem>
                      <MenuItem value={0}>Inativo</MenuItem>
                      <MenuItem value={1}>Ativo</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item xs>
              <Grid
                container
                spacing={2}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <IconButton
                    className={filterClasses.btnAdd}
                    onClick={handleReportExport}
                  >
                    <Icon
                      path={mdiMicrosoftExcel}
                      size={1}
                      style={{ marginRight: '4px' }}
                    />
                    Download
                  </IconButton>
                </Grid>

                <Grid item>
                  {canCreate('formas-pagamento', permissionUser) && (
                    <IconButton
                      component={Link}
                      to={`/payment-method/new${location.search}`}
                      className={filterClasses.btnAdd}
                    >
                      <Icon
                        path={mdiNoteEditOutline}
                        size={1}
                        style={{ marginRight: '4px' }}
                      />
                      Cadastrar
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}